export default __webpack_public_path__ + "static/media/paint-brush.01e8c36c.png";